export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9213.893e98bf.jpg";